import { render } from "./folder.vue?vue&type=template&id=5016aa58"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/folder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5016aa58"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5016aa58', __exports__)) {
    api.reload('5016aa58', __exports__)
  }
  
  module.hot.accept("./folder.vue?vue&type=template&id=5016aa58", () => {
    api.rerender('5016aa58', render)
  })

}


export default __exports__